<h1 mat-dialog-title>
  Request Access @if (data) {
  <span> to {{data}}</span>
}

<button mat-icon-button mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>

</h1>

<div mat-dialog-content class="content">
  <mat-form-field appearance="outline" floatLabel="always" >
    <mat-label>Reason</mat-label>
    <textarea matInput [formControl]="reasonControl" cdkTextareaAutosize  cdkAutosizeMaxRows="5" cdkAutosizeMinRows="5" ></textarea>
  </mat-form-field>
</div>

<div class="actions" mat-dialog-actions>
  <button mat-flat-button color="primary" [disabled]="reasonControl.invalid" [mat-dialog-close]="reasonControl.value" >Submit</button>
</div>
